import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  EXTERNAL_LINKS,
  MEMBERSHIP_LINKS,
  STANDARD_DOWNSELL_FEATURES,
  STANDARD_DOWNSELL_HEADLINE,
  STANDARD_DOWNSELL_SUBHEAD,
} from "@/lib/constants";
import { NEXT_COHORT_PATH } from "@/lib/cohorts";
import { useSEO } from "@/lib/use-seo";

const SelfPacedOffer = () => {
  useSEO({
    title: "Start Self-Paced — AI for HR Mastermind",
    description: STANDARD_DOWNSELL_SUBHEAD,
    path: "/self-paced",
    noindex: true,
  });

  return (
    <div className="min-h-screen bg-background pt-28 pb-16">
      <div className="section-inner max-w-xl">
        <div className="glass-card p-8 md:p-10 space-y-6 text-center">
          <h1 className="text-3xl md:text-4xl font-bold">{STANDARD_DOWNSELL_HEADLINE}</h1>
          <p className="text-lg text-foreground/80 leading-relaxed">
            {STANDARD_DOWNSELL_SUBHEAD}
          </p>

          <div className="rounded-xl border border-border bg-card p-5 text-left">
            <p className="text-sm font-semibold uppercase tracking-wider text-muted-foreground mb-3">
              Standard Membership
            </p>
            <p className="text-3xl font-bold text-primary mb-1">$30/month</p>
            <p className="text-sm text-muted-foreground mb-4">Billed annually at $360</p>
            <ul className="space-y-2">
              {STANDARD_DOWNSELL_FEATURES.map((feature) => (
                <li key={feature} className="flex items-start gap-2 text-sm text-foreground/80">
                  <Check className="w-4 h-4 mt-0.5 flex-shrink-0 text-secondary" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>

          <Button asChild size="lg" className="w-full sm:w-auto">
            <a
              href={MEMBERSHIP_LINKS.STANDARD}
              target="_blank"
              rel="noopener noreferrer"
            >
              Join Standard
              <ArrowRight className="w-4 h-4 ml-2" />
            </a>
          </Button>

          <p className="text-sm text-muted-foreground">
            Still interested in a live cohort?{" "}
            <a
              href={EXTERNAL_LINKS.PREMIUM_MASTERMIND_APPLICATION}
              className="font-medium text-primary hover:text-primary/80 underline underline-offset-4"
            >
              Apply for Premium
            </a>{" "}
            or{" "}
            <Link
              to={NEXT_COHORT_PATH}
              className="font-medium text-primary hover:text-primary/80 underline underline-offset-4"
            >
              learn about the next cohort
            </Link>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default SelfPacedOffer;
